module.exports = __webpack_public_path__ + "static/media/banner3.cbbc2e53.jpg";